import removeDuplicates from '@anm/helpers/array/removeDuplicates';
import { FC } from 'react';

import VideoRatioList from './VideoRatioList';
import { VideoRatioListWrapper } from './Wrapper';
import { useRatioList } from './hooks';
import { VideoRatiosProps } from './types';
export * from './types';

const VideoRatios: FC<VideoRatiosProps> = props => {
  const [list, videoFormats] = useRatioList(props);

  const uniqueFormatsList = removeDuplicates(list, 'format');
  const uniqueNamesList = removeDuplicates(uniqueFormatsList, 'displayName');

  return (
    <VideoRatioListWrapper>
      <VideoRatioList list={uniqueNamesList} {...{ videoFormats, ...props }} />
    </VideoRatioListWrapper>
  );
};

export default VideoRatios;
